import { css } from 'emotion';

export const fade = {
  enter: css`
    opacity: 0;
  `,
  enterActive: css`
    opacity: 1;
    transition: opacity 250ms ease-in;
  `,
  exit: css`
    display: none;
  `
};
